// extracted by mini-css-extract-plugin
export default {"root":"DwrLk6"};